import { useEffect, useState } from "react";

export default function BrandLogo({ variant, className = "h-10 w-auto", testId = "brand-logo" }) {
  const [theme, setTheme] = useState(() => document.documentElement.dataset.theme || "dark");
  useEffect(() => {
    const obs = new MutationObserver(() => setTheme(document.documentElement.dataset.theme || "dark"));
    obs.observe(document.documentElement, { attributes: true, attributeFilter: ["data-theme"] });
    return () => obs.disconnect();
  }, []);
  const v = variant || theme;
  return (
    <img
      src={v === "light" ? "/brand/kmc-logo-light.png" : "/brand/kmc-logo-dark.png"}
      alt="KMC Solutions — Private Wealth Portal"
      className={className}
      data-testid={testId}
      draggable={false}
    />
  );
}
